import React from "react";
import { KeyboardArrowUpOutlined, KeyboardArrowDownOutlined } from "@mui/icons-material";
import { styled } from "@mui/material";
import { SortDirection } from "@tanstack/react-table";

export const SortButton: React.FC<{
  isSorted: SortDirection | false;
}> = ({ isSorted }) => {
  const sortIconMap: { [key in SortDirection]: React.ReactNode } = {
    asc: <KeyboardArrowUpOutlined />,
    desc: <KeyboardArrowDownOutlined />,
  };

  return (
    <StyledButton>
      {isSorted ? (
        sortIconMap[isSorted]
      ) : (
        <div>
          <KeyboardArrowUpOutlined />
          <KeyboardArrowDownOutlined />
        </div>
      )}
    </StyledButton>
  );
};

const StyledButton = styled("div")(({ theme }) => ({
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  paddingLeft: "2px",
  height: "-webkit-fill-available",

  svg: {
    fontSize: "1rem",
    fill: theme.tokens.colors.gray[5],
  },
  ">div": {
    display: "flex",
    flexDirection: "column",
    "svg:last-child": {
      marginTop: "-7px",
    },
  },
}));
